export const APPROVAL_TYPES = {
  CREDIT_LINE: 'CreditLineRequest',
  FACTORING_QUOTE: 'FactoringRequest',
  CONFIRMING: 'ConfirmingRequest',
  FACTORING_RESELL: 'FactoringResell',
  CREDIT_REQUEST: 'CreditRequest',
  FACTORING_EXTENSION: 'FactoringExtension',
  WARRANTY_REQUEST: 'SGRWarrantyRequest',
  PAYMENT_REQUEST_PASSIVE: 'PaymentRequestPassive',
} as const;

export type ApprovalType = (typeof APPROVAL_TYPES)[keyof typeof APPROVAL_TYPES];

export const COMITEE_TYPES = {
  RISK: 'RISK',
  OPERATIONS: 'OPERATIONS',
} as const;

export type ComiteeType = (typeof COMITEE_TYPES)[keyof typeof COMITEE_TYPES];

export const APPROVAL_STATUS = {
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  PENDING: 'PENDING',
} as const;

export type ApprovalStatus =
  (typeof APPROVAL_STATUS)[keyof typeof APPROVAL_STATUS];

export type GetMissingApprovalsResponse = {
  comiteeName: string;
  roles: RoleApproval[];
  isFullyApproved: boolean;
  isRejected: boolean;
};

export type RoleApproval = {
  roleId: number;
  roleName: string;
  requiredApprovals: number;
  approved: Approval[];
  rejected: Approval[];
  userCanApprove: boolean;
};

export type Approval = {
  id: number;
  status: ApprovalStatus;
  reason: string;
  type: ApprovalType;
  comiteeType: ComiteeType;
  createdAt: string;
  updatedAt: string;
  userId: number;
  user: {
    email: string;
    name: string;
  };
  role: {
    id: number;
    name: string;
  };
};
